function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2296_3816)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.6521 48.98C38.3976 43.3504 38.3086 37.2042 35.3804 32.1947C34.5995 30.8397 33.6723 29.6426 32.5929 28.5603C30.4657 26.4417 28.815 23.8063 27.8619 20.97C25.5079 14.241 27.3423 5.97031 33.1699 1.75316C34.2378 0.978057 35.3976 0.369456 36.6521 0.0220947C35.4522 4.00097 35.0704 8.41045 36.101 12.263C36.9335 15.4668 38.455 18.1595 40.7114 20.4447C42.8358 22.569 44.4836 25.2044 45.4338 28.0407C47.3256 33.5095 46.5103 39.9429 43.0051 44.4442C41.3688 46.5456 39.2042 48.2451 36.655 48.9857L36.6521 48.98Z",
  fill: "#204FC7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.7704 48.9487C22.1885 44.3784 22.1139 39.3862 19.7398 35.3183C19.1053 34.2188 18.3532 33.2456 17.4748 32.3672C15.7466 30.6476 14.4059 28.506 13.6308 26.2036C11.7189 20.7377 13.2088 14.023 17.9398 10.5982C18.8068 9.9695 19.7484 9.47573 20.7675 9.19153C19.7915 12.4211 19.4814 16.0038 20.3197 19.1301C20.9972 21.731 22.2316 23.9185 24.0631 25.773C25.7885 27.4984 27.1262 29.6371 27.8985 31.9394C29.4343 36.3805 28.7712 41.6053 25.9263 45.2597C24.5971 46.965 22.8402 48.3458 20.7704 48.9458V48.9487Z",
  fill: "#0282F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.93079 48.9573C8.06474 45.3029 8.00733 41.3096 6.10689 38.0571C5.60163 37.1786 4.99877 36.4007 4.29544 35.6973C2.91173 34.3222 1.84094 32.6084 1.22373 30.7682C-0.306388 26.3989 0.887847 21.0277 4.67151 18.289C5.36336 17.7867 6.11837 17.3905 6.93366 17.1637C6.15282 19.7474 5.90593 22.6124 6.57482 25.1128C7.11739 27.1941 8.10206 28.9424 9.56902 30.4266C10.947 31.8046 12.0178 33.5184 12.635 35.3586C13.8637 38.9097 13.3326 43.0866 11.0561 46.012C9.99389 47.3756 8.58722 48.4808 6.93366 48.9602L6.93079 48.9573Z",
  fill: "#1AABFF"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2296_3816"
}, /*#__PURE__*/React.createElement("rect", {
  width: 45.8489,
  height: 48.9608,
  fill: "white",
  transform: "translate(0.575195 0.0196533)"
})));

var SvgSellfireLogo = function SvgSellfireLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSellfireLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sellfire_logo.ef14c7f9.svg";
export { ForwardRef as ReactComponent };